<nb-card>
  <nb-card-header>
    Client Checkin
  </nb-card-header>
  <nb-card-body [nbSpinner]="isLoading">
    <form [formGroup]="form">
      <div class="row align-items-stretch">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <nb-card class="assessment-setting-block">
            <nb-card-header>
              CheckIn Setting
            </nb-card-header>
            <nb-card-body class="d-flex flex-column" style="gap: 20px;">
              <nb-checkbox formControlName="uploadProgressImages">Allow To Upload Progress Images</nb-checkbox>
              <div class="d-flex align-items-center">
                <label class="mr-3">CheckIn Frequency</label>
                <div class="flex-grow-1">
                  <nb-select formControlName="assessmentFrequency" placeholder="CheckIn Frequency">
                    <nb-option value="weekly">Weekly</nb-option>
                    <nb-option value="monthly">Monthly</nb-option>
                    <nb-option value="biWeekly">BiWeekly</nb-option>
                  </nb-select>
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="d-flex flex-wrap">
                  <button nbButton *ngFor="let day of daysOfWeek" shape="round" size="small" status="primary"
                    class="mr-1 mb-1" [appearance]="form.get('daysOfWeek').value?.includes(day) ? 'filled' : 'outline'"
                    (click)="onDaySelectChange(day)">
                    {{ day }}
                  </button>
                </div>
                <p class="text-small mt-2">Select on which day you want the system to prompt your client to checkin. Not selecting any day will
                  disable prompt.</p>
              </div>
            </nb-card-body>
          </nb-card>

        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <nb-card>
            <nb-card-header>Message</nb-card-header>
            <nb-card-body>
              <div>
                <nb-checkbox formControlName="sendByEmail" class="mr-3">Send By Email</nb-checkbox>
                <nb-checkbox formControlName="sendByMessage">Send by TrainerFriend Chat</nb-checkbox>
              </div>
              <angular-editor formControlName="messageText"></angular-editor>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <nb-card>
            <nb-card-header>CheckIn Form</nb-card-header>
            <nb-card-body>
              <div class="row" cdkDropListGroup>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <nb-tabset>
                    <nb-tab tabTitle="fields">
                      <div cdkDropList #availableFields="cdkDropList" [cdkDropListData]="fields" class="list-group">
                        <div class="list-group-item" *ngFor="let field of fields" cdkDrag>{{ field.name }}</div>
                      </div>
                    </nb-tab>
                    <nb-tab tabTitle="default fields">
                      <div cdkDropList #availableFields="cdkDropList" [cdkDropListData]="defaultFields"
                        class="list-group">
                        <div class="list-group-item" *ngFor="let field of defaultFields" cdkDrag>{{ field.name }}</div>
                        <div *ngIf="defaultFields.length === 0" class="text-center">All default fields are used</div>
                      </div>
                    </nb-tab>
                  </nb-tabset>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <button nbButton status="primary" class="mb-3" (click)="previewForm = !previewForm">{{previewForm? 'Hide Preview': 'Preview'}}</button>
                  <div cdkDropList *ngIf="!previewForm" #formStructure="cdkDropList" [cdkDropListData]="formStructureFields"
                    class="list-group" style="min-height: 100%; border: 1px solid rgba(0, 0, 0, 0.125);"
                    (cdkDropListDropped)="drop($event)" [cdkDropListConnectedTo]="['availableFields']">
                    <div class="w-100 h-100 d-flex justify-content-center align-items-center flex-grow-1"
                      *ngIf="formStructureFields.length === 0">
                      <div>
                        Drag and drop fields here
                      </div>
                    </div>
                    <div class="list-group-item" *ngFor="let field of formStructureFields; let i = index" cdkDrag>
                      <div class="delete-icon">
                        <button *ngIf="!field.defaultField" nbButton static="basic" ghost shape="round" size="small"
                          (click)="addDuplicate(field)" class="ml-auto">
                          <nb-icon icon="copy"></nb-icon>
                        </button>
                        <button nbButton static="basic" ghost shape="round" size="small" (click)="deleteField(i)"
                          class="ml-auto">
                          <nb-icon icon="close"></nb-icon>
                        </button>
                        <button nbButton static="basic" *ngIf="!field.defaultField" ghost shape="round" size="small"
                          (click)="editField(i)">
                          edit
                        </button>
                      </div>
                      <div class="pt-3">
                        <formly-form [fields]="[field]"  [options]="options"></formly-form>
                      </div>
                    </div>
                  </div>
                  <div>
                    <formly-form *ngIf="previewForm" [fields]="formStructureFields"  [options]="options"></formly-form>
                  </div>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="primary" [disabled]="isLoading"  [nbSpinner]="isLoading" (click)="onSubmit()">Save</button>
  </nb-card-footer>
</nb-card>
